import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";

const LayoutHeader = ({ hideHeaderPaths = [], categories, products }) => {
  const { pathname } = useLocation();

  return (
    <>
      {!hideHeaderPaths.includes(pathname) && (
        <Header categories={categories} products={products} />
      )}
      <Outlet />
    </>
  );
};

export default LayoutHeader;
